import { z } from "zod";
import { accountRoleSchema, accountTypeSchema } from "./account.schema";

export const coaPostApplySnapshotAccountSchema = z.object({
    id: z.string().uuid(),
    code: z.number().int(),
    codeText: z.string().nullable(),
    name: z.string(),
    type: accountTypeSchema,
    isDisabled: z.boolean(),
    isManuallyCreated: z.boolean(),
    role: accountRoleSchema.unwrap(),
    parentGroupId: z.string().uuid().nullable(),
    groupPath: z.array(z.string()),
    sortOrder: z.number(),
    sourceTemplateAccountId: z.string().uuid().nullable(),
});

export const coaPostApplySnapshotGroupSchema = z.object({
    id: z.string().uuid(),
    entityId: z.number().int(),
    name: z.string(),
    type: accountTypeSchema,
    parentGroupId: z.string().uuid().nullable(),
    sortOrder: z.number(),
    path: z.array(z.string()),
});

export const coaPostApplySnapshotSchema = z.object({
    entityId: z.number().int(),
    workspaceId: z.string().uuid(),
    accounts: z.array(coaPostApplySnapshotAccountSchema),
    groups: z.array(coaPostApplySnapshotGroupSchema),
});

export type CoaPostApplySnapshot = z.infer<typeof coaPostApplySnapshotSchema>;
export type CoaPostApplySnapshotAccount = z.infer<
    typeof coaPostApplySnapshotAccountSchema
>;
export type CoaPostApplySnapshotGroup = z.infer<
    typeof coaPostApplySnapshotGroupSchema
>;
